import { isFilled } from "@/ipqc/lib/utils"
import { UseFormReturn, ValidateFn } from "@/lib/form/form"
import { ParamSchema } from "@/lib/form/schema"
import * as y from "yup"

const fieldValidator = y
  .object({
    id: y.string().optional(),
    value: y
      .string()
      .min(1)
      .transform((value) => (value ? value : undefined))
      .optional(),
    remark: y.string().optional(),
    recordedAt: y.string().optional(),
  })
  .test({
    name: "test-choice-input",
    test: function (value, ctx) {
      const context = ctx.options.context as
        | {
          required: boolean
          schema: ParamSchema
          form: UseFormReturn
          path: string
        }
        | undefined

      if (!context?.schema.choices) {
        return ctx.createError({
          message: `${context?.path} choices missing in the schema`,
        })
      }

      if (context.required && !isFilled(value.value)) {
        return ctx.createError({ message: `${context.path} value is required` })
      }

      if (!value.value) {
        return true
      }

      const fieldValue = context.form.getState(`values.${context.path}`)

      const selected = context.schema.choices.find(
        (choice) => choice.value === value.value
      )

      if (!selected) {
        return ctx.createError({ message: `${context?.path} invalid choice` })
      }

      if (!selected?.isCorrect && !fieldValue.remark) {
        return ctx.createError({ message: `${context?.path} remarks required` })
      }

      return true
    },
  })

export const choiceValiSchema = y
  .object({})
  .concat(fieldValidator)
  .concat(
    y.object({
      window: y.array(fieldValidator),
    })
  )

export function createChoiceValidator({
  schema,
  path,
  form,
  isHandover,
  required,
}: {
  schema: ParamSchema
  path: string
  form: UseFormReturn
  isHandover?: boolean
  required?: boolean
}): ValidateFn {
  return (value: any) => {
    try {
      const finalSchema =
        isHandover || required ? choiceValiSchema.required() : choiceValiSchema

      finalSchema.validateSync(value, {
        context: {
          required: !!(isHandover || required),
          schema: schema,
          form: form,
          path: path,
        },
      })

      return false
    } catch (err) {
      return err as y.ValidationError
    }
  }
}
